import { LinkButton } from '@/components/ui/Button';
import { EmptyState } from '@/components/ui/Feedback';

export function NotFoundPage() {
  return (
    <EmptyState
      title="That page does not exist"
      description="The link may be out of date, or the task may have been archived."
      action={
        <LinkButton to="/" variant="primary">
          Back to the dashboard
        </LinkButton>
      }
    />
  );
}
